import { CreateSalesOrderEditorWorkspace } from "./createSalesOrderEditorWorkspace";

/**
 * Sales order editor shell — state and layout live in createSalesOrderEditorWorkspace.tsx.
 * Types/helpers: createSalesOrderPageModel.ts, createSalesOrderPageUi.tsx.
 */
export function CreateSalesOrderPage() {
  return <CreateSalesOrderEditorWorkspace />;
}
